import { useEffect, useMemo, useRef, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import chatStoreManager from '@/store/chat/manager';
import VncViewerCard from './card';
import "./index.scss";
import EE from '@/common/event';
import { debounce, throttle } from 'lodash-es';
import { HelperCore } from '@/common/dependencies';

const VncViewer = observer((props) => {
  const {
    refView,
    refViewContainer,
  } = props;

  const [currentCardId, setCurrentCardId] = useState('');
  const mcpStore = chatStoreManager.current?.mcpStore;
  const isCompleted = chatStoreManager.current.lastMessage?.is_doing == 0;
  
  const store = useLocalObservable(() => ({
    lastScrollTop: 0,
    stopScroll: false,
    autoScroll: true,

    setLastScrollTop(val) {
      this.lastScrollTop = val;
    },
    setStopScroll(val) {
      this.stopScroll = val;
    },
    setAutoScroll(val) {
      this.autoScroll = val;
    },
  }));

  const updateCurrentCardId = () => {
    const id = `card_${mcpStore?.panelMessageId}_${mcpStore?.currentPanelId}`;
    setCurrentCardId(id)
  }

  const scrollFn = throttle(() => {
    const id = `card_${mcpStore?.panelMessageId}_${mcpStore?.currentPanelId}`;
    const vncviewer = document.querySelector('#vncviewer');
    const currentDom = vncviewer?.querySelector(`[data-id="${id}"]`);
    if (currentDom) {
      const outerDom = currentDom?.querySelector('[data-flag]');
      const viewerHeight = vncviewer?.offsetHeight;
      const cardHeight = (currentDom?.offsetHeight || 0) + (outerDom?.offsetHeight || 0);
      const cardOffsetTop = currentDom?.offsetTop || 0;
      let top = cardOffsetTop - 20;
      if (cardHeight < viewerHeight) {
        top = cardOffsetTop + cardHeight - viewerHeight + 32
      }
      vncviewer?.scrollTo({
        top,
        behavior: 'smooth',
      })
    }
  }, 50, {leading: false, trailing: true});

  const handleScroll = (flag = true) => {
    if (mcpStore.panelMessageId && mcpStore.currentPanelId) {
      if (flag || store.autoScroll) {
        scrollFn();
      }
    }
  }

  const scroll = throttle(() => {
    const el = refView?.current;
    const scrollHeight = el.scrollHeight;
    const offsetHeight = el.offsetHeight;
    const scrollTop = el.scrollTop;
    const distance =  scrollTop - store.lastScrollTop;
    const distanceDiff = 150;

    if (store.stopScroll) {
      return;
    }

    if (store.autoScroll) {
      if (distance < -distanceDiff) {
        store.setAutoScroll(false)
      } else {
        store.setAutoScroll(true)
      }
    } else {
      if (scrollTop + offsetHeight + distanceDiff > scrollHeight) {
        store.setAutoScroll(true)
      }
    }

    store.setLastScrollTop(scrollTop)
  }, 200)

  useEffect(() => {
    updateCurrentCardId();
    handleScroll(false);
  }, [mcpStore.panelMessageId, mcpStore.currentPanelId]);

  const resizeScrollFn = throttle((entries) => {
    let height = 0;
    const elView = refView?.current;
    for (let entry of entries) {
      height = entry.contentRect.height;
    }
    if (store.autoScroll && !store.stopScroll) {
      elView?.scrollTo({
        top: height,
        behavior: 'smooth',
      })
    }
  }, 50, {leading: false, trailing: true});

  useEffect(() => {
    EE.on("vnc-cards-scroll", handleScroll);

    const elView = refView?.current;
    elView?.addEventListener('scroll', scroll);

    const elViewContainer = refViewContainer?.current;
    const resizeObserver = new ResizeObserver(entries => {
      resizeScrollFn(entries)
    });
    resizeObserver.observe(elViewContainer);

    return () => {
      EE.off("vnc-cards-scroll", handleScroll);
      elView?.removeEventListener('scroll', scroll);
      resizeObserver.disconnect();
    }
  }, []);

  useEffect(() => {
    store.setStopScroll(mcpStore.hasSelectedPanelId ? true : false)
  }, [mcpStore.hasSelectedPanelId]);

  const continueScroll = () => {
    mcpStore.setContinue();
    store.setAutoScroll(true);
  }

  let lastMsgId;

  return (
    <>
      
      {
        (mcpStore.toolsNodes || []).map(item => {
          const {
            event, // 透传过来的event
          } = item;
          const id = `card_${event?.msg_id}_${event?.planStepId}`
          const newMsg = lastMsgId === event?.msg_id ? 0 : 1;
          lastMsgId = event?.msg_id;

          if(HelperCore.isPhone() && event?.planStepId != mcpStore.currentPanelId){
            return null;
          }

          return (
            <VncViewerCard 
              key={id} 
              item={item} 
              mcpStore={mcpStore} 
              currentCardId={currentCardId}
              newMsg={newMsg}
              />
          )
        })
      }
      {
        !isCompleted && store.stopScroll ? (
          <div
            className='size-32px rounded-full cursor-pointer flex justify-center items-center border-1px  bg-[#fff] hover:bg-[#F6F7F9] border-[rgba(0,0,0,0.1)] fixed right-28px bottom-20px z-2'
            onClick={() => {
              continueScroll()
            }}
          >
            <svg className="size-16px text-[#000]">
              <use className="svg-icon" href="#icon-back_bottom"></use>
            </svg>
          </div>
        ) : null
      }
      <div className='h-32px'></div>
    </>
  )
});

export default VncViewer;